
import Vue from 'vue';
import {saveAs} from 'file-saver';
import EventService from '@/services/EventService';
import axios from 'axios';
import {mapState} from 'vuex';
import WarningDialog from '../components/WarningDialog.vue'; // TODO (ohtsuchi) 2025年以降 コードを削除
import store, { // TODO (ohtsuchi) 2025年以降 コードを削除
  ConfSortByType, // TODO (ohtsuchi) 2025年以降 コードを削除
  ConfSortByValue, // TODO (ohtsuchi) 2025年以降 コードを削除
} from '@/store'; // TODO (ohtsuchi) 2025年以降 コードを削除
import {expiredConfSortBy} from '@/services/Conf'; // TODO (ohtsuchi) 2025年以降 コードを削除
import type {User} from 'firebase/auth';

type Scope = {
  name: string;
  description: string;
  styleClass: string;
};

const scopeDescriptions = new Map<string, string>([
  ['truck', 'トラック'],
  ['forklift', 'フォークリフト'],
]);

const scopeStyleClasses = new Map<string, string>([
  ['truck', 'truck-title'],
  ['forklift', 'forklift-title'],
]);

const scopeOrder = new Map<string, number>([
  ['truck', 1],
  ['forklift', 2],
]);

const mainDescriptions = new Map<boolean, string>([
  [true, '12項目'],
  [false, 'ヒヤリハット'],
]);

type noSubGroup = {
  scope: string;
  startYear: number;
};

// TODO (ohtsuchi) 固定値ではなく、サーバー側から設定値を取得する
const NO_SUB_GROUP_SCOPES: noSubGroup[] = [
  {
    scope: 'forklift',
    startYear: 2025,
  },
];

function convertForbiddenFilenameCharToFullWidth(input: string): string {
  const FULLWIDTH_MAP: Record<string, string> = {
    '\\': '＼',
    '/': '／',
    ':': '：',
    '*': '＊',
    '?': '？',
    '"': '＂',
    '<': '＜',
    '>': '＞',
    '|': '｜',
  };
  // 正規表現で対象文字をまとめて検索し、マップに従って置換する
  return input.replace(/[\\/:*?"<>|]/g, (match: string) => {
    return FULLWIDTH_MAP[match] || match;
  });
}

const minYear = 2020;

const baseURL = EventService.ProtoURL();
const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

type Data = {
  scopes: string[];
  isLoading: boolean;
  snackbar: boolean;
  snackbarMessage: string;
  snackbarColor: string;
  confPanel: number[]; // TODO (ohtsuchi) 2025年以降 コードを削除
  confWarningDialog: boolean; // TODO (ohtsuchi) 2025年以降 コードを削除
  confSortBy: ConfSortByType; // TODO (ohtsuchi) 2025年以降 コードを削除
};

type Method = {
  download(year: number, scope: string, main: boolean): Promise<void>;
  handleConfSortBy(val: ConfSortByType): void;
  cancelConfSortBy(): void;
  setConfSortBy(val: ConfSortByType): Promise<void>;
  isNoSubGroup(year: number, scope: string): boolean;
  expiredConfSortBy(): boolean;
};

type Computed = {
  reverseYears: number[];
  orderedScopes: Scope[];
  boGroupName: string;
  confExpandMsg: string;
  user: User | undefined;
  accountName: string;
  sortBy: ConfSortByType;
};

type Props = {
  maxYear: number;
  scopesCSV: string;
};

export default Vue.extend<Data, Method, Computed, Props>({
  components: {
    WarningDialog, // TODO (ohtsuchi) 2025年以降 コードを削除
  },
  props: {
    maxYear: {
      type: Number,
      default: minYear,
    },
    scopesCSV: {
      type: String,
      default: '',
    },
  },
  async created() {
    this.scopes = this.scopesCSV.split(',');
  },
  async mounted() {
    if (this.user) {
      // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここから
      this.confSortBy = this.sortBy as ConfSortByType;
      // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここまで
    }
  },
  data: (): Data => ({
    scopes: [],
    isLoading: false,
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: '',
    confPanel: [], // TODO (ohtsuchi) 2025年以降 コードを削除
    confWarningDialog: false, // TODO (ohtsuchi) 2025年以降 コードを削除
    confSortBy: ConfSortByValue.Default, // TODO (ohtsuchi) 2025年以降 コードを削除
  }),
  methods: {
    async download(year: number, scope: string, main: boolean) {
      if (this.user) {
        try {
          this.isLoading = true;
          const token = await this.user.getIdToken();
          const {data} = await apiClient.get(
            `/groups/chart/?year=${year}&scope=${scope}&main=${main}&target=all`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              responseType: 'blob',
            }
          );
          const mainDesc = this.isNoSubGroup(year, scope)
            ? ``
            : `-${mainDescriptions.get(main)}`;
          saveAs(
            new Blob([data]),
            `chart-${year}年度-${scopeDescriptions.get(scope)}${mainDesc}-${
              this.boGroupName
            }-全営業所.xlsx`
          );
          this.snackbarMessage = 'ダウンロードが成功しました';
          this.snackbarColor = 'success';
          this.snackbar = true;
        } catch (error) {
          console.error('Download failed:', error);
          this.snackbarMessage = 'ダウンロードが失敗しました';
          this.snackbarColor = 'error';
          this.snackbar = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
    // TODO (ohtsuchi) 2025年以降 コードを削除
    handleConfSortBy(val: ConfSortByType) {
      if (val === ConfSortByValue.Changed) {
        this.confWarningDialog = true; // デフォルトから変更する前に警告表示
        return;
      }
      this.setConfSortBy(val);
    },
    // TODO (ohtsuchi) 2025年以降 コードを削除
    cancelConfSortBy() {
      this.confWarningDialog = false;
      this.confSortBy = ConfSortByValue.Default;
    },
    // TODO (ohtsuchi) 2025年以降 コードを削除
    async setConfSortBy(val: ConfSortByType) {
      this.confWarningDialog = false;
      if (this.user) {
        try {
          const token = await this.user.getIdToken();
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
          if (val === ConfSortByValue.Default) {
            await apiClient.post(
              `/groups/conf/sortBy/delete/?target=all`,
              {},
              config
            );
            store.commit('CLEAR_SORT_BY');
          } else if (val === ConfSortByValue.Changed) {
            await apiClient.post(
              `/groups/conf/sortBy/register/?target=all`,
              {},
              config
            );
            store.commit('SET_SORT_BY', ConfSortByValue.Changed);
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    isNoSubGroup(year: number, scope: string): boolean {
      const notFoundScopeYear = 0;
      const noSubGroupStartYear = (scope: string): number => {
        const found = NO_SUB_GROUP_SCOPES.find(
          (n: noSubGroup) => n.scope === scope
        );
        return found ? found.startYear : notFoundScopeYear;
      };
      // TODO (ohtsuchi) 固定値ではなく、サーバー側から設定値を取得する
      const startYear = noSubGroupStartYear(scope);
      return startYear != notFoundScopeYear && startYear <= year;
    },
    // TODO (ohtsuchi) 2025年以降 コードを削除
    expiredConfSortBy,
  },
  computed: {
    reverseYears(): number[] {
      const length = this.maxYear - minYear + 1;
      return Array.from({length}, (_, index) => minYear + index).reverse();
    },
    orderedScopes(): Scope[] {
      const tmpScopes = [...this.scopes]; // sort が 破壊的メソッドのため 事前に copy
      return tmpScopes
        .sort((a, b) => (scopeOrder.get(a) ?? 0) - (scopeOrder.get(b) ?? 0))
        .map((scope: string) => {
          return {
            name: scope,
            description: scopeDescriptions.get(scope) ?? '',
            styleClass: scopeStyleClasses.get(scope) ?? 'grey',
          };
        });
    },
    boGroupName(): string {
      return convertForbiddenFilenameCharToFullWidth(this.accountName);
    },
    // TODO (ohtsuchi) 2025年以降 コードを削除
    confExpandMsg(): string {
      return this.confPanel.length > 0 ? '閉じる' : '開く';
    },
    ...mapState([
      'user',
      'accountName',
      'sortBy', // TODO (ohtsuchi) 2025年以降 コードを削除
    ]),
  },
});
